var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingleTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 6
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#249995",
    fillRule: "evenodd",
    stroke: "#249995",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.4,
    d: "M1.554 4.126a.295.295 0 00-.46.005.42.42 0 00.004.534L2.274 6l3.635-4.36a.422.422 0 00-.009-.534.294.294 0 00-.46.01L2.26 4.927l-.707-.802z"
  })));
}
export default SvgSingleTick;